// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"Completed_infoWrapper__22jqi","icon":"Completed_icon__1Yr7K"};